import EstimateField from "./estimate";
import normalizeNumber from "../../import/normalize/normalize-number";
// import FieldTimeReportViewInImport from "../../import/view-in-preview/timereport-in-import";

export default class EstimateFieldHours extends EstimateField {
    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.ESTIMATE_HOURS;
        this.formulaCompatible = false;
    }

    getCsvValue(item) {
        let res = item.estimate;
        if (res) res = gd.utils.Time.roundHours(res);
        return res;
    }


    // IMPORT

    normalizeCSVValue(value) {
        value = normalizeNumber(value);

        // 0 supported
        if (!_.isNil(value)) {
            return value * 60;
        }
        return null;
    }

    // getComponentViewInImport() {
    //     return FieldTimeReportViewInImport;
    // }

}
